export const getSafeReturnUrl = (raw: string | null): string | null => {
  const FORBIDDEN_SCHEMES = /^(javascript|data|vbscript|file):/i;
  const DEFAULT = null;

  if (!raw || FORBIDDEN_SCHEMES.test(raw.trim())) {
    return DEFAULT;
  }

  try {
    const url = new URL(raw, 'https://www.cian.ru');

    if (url.protocol !== 'https:' || !url.hostname.endsWith('cian.ru')) {
      return DEFAULT;
    }

    const innerReturnUrl = url.searchParams.get('returnUrl');

    if (innerReturnUrl) {
      if (FORBIDDEN_SCHEMES.test(innerReturnUrl.trim())) {
        return DEFAULT;
      }

      return getSafeReturnUrl(innerReturnUrl);
    }

    return url.toString();
  } catch {
    return DEFAULT;
  }
};
